export default {
    "slug": "ember",
    "title": "Ember Tactics",
    "firstChapterKey": "2",
    "chapters": {
        "2": require("./2").default,
    },
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0,
            "items": {},
        },
        "perks": [],
        "party": {
            "units": {
                "swordlord": {
                    "key": "swordlord",
                    "jobKey": "sword",
                    "affiliation": "good",

                    "isRecruited": true,
                    "hasSlowDeath": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "rally",
                    ],

                    "name": "Elarc",
                    "jobName": "Swordlord",
                    "faceKey": "fox",
                    "bodyKey": "good",

                    "dialogue": {
                        "death": [
                            "Think nothing of it. I will not fall this day.",
                        ],
                        "slowdeath": [
                            "Please forgive me.",
                        ],
                    },
                },
                "onionknight": {
                    "key": "onionknight",
                    "jobKey": "hammerknight",
                    "affiliation": "good",

                    "isRecruited": true,
                    "hasSlowDeath": true,

                    "maxhealth": 35,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "swap",
                    ],

                    "name": "Ambrosi",
                    "jobName": "Onionknight",
                    "faceKey": "fox",
                    "bodyKey": "good",

                    "dialogue": {
                        "death": [
                            "Bahaha!! A fine blow. Let me show you mine.",
                        ],
                        "slowdeath": [
                            "I am Ambrosi, Son of Neptar, Wielder of the Hearthaxe, and Knight of the Realm.",
                            "Let the weapon that felled me be remembered as the AMBROSI-SLAYER."
                        ],
                    },
                },
                "dragoon": {
                    "key": "dragoon",
                    "jobKey": "spearcavalier",
                    "affiliation": "good",

                    "isRecruited": true,
                    "hasSlowDeath": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "suplex",
                    ],

                    "name": "Percival",
                    "jobName": "Dragoon",
                    "faceKey": "fox",
                    "bodyKey": "good",

                    "dialogue": {
                        "death": [
                            "Nobody saw that, right?",
                        ],
                        "slowdeath": [
                            "Tell them-",
                            "Tell them I died to a dragon.",
                        ],
                    },
                },
                "firekeeper": {
                    "key": "firekeeper",
                    "jobKey": "shaman",
                    "affiliation": "good",

                    "isRecruited": true,
                    "hasSlowDeath": true,

                    "maxhealth": 15,
                    "defense": 3,
                    "skills": [
                        "inflict-damage",
                        "restore-health",
                    ],

                    "name": "Mara",
                    "jobName": "Firekeeper",
                    "faceKey": "fox",
                    "bodyKey": "good",

                    "dialogue": {
                        "death": [
                            "...",
                        ],
                        "slowdeath": [
                            "The hearth lands are real.",
                            "I will not reach them with you.",
                            "But know they are real, and they are warm.",
                        ],
                    },
                },
                "squire": {
                    "key": "squire",
                    "jobKey": "bow",
                    "affiliation": "good",

                    "isRecruited": true,
                    "hasSlowDeath": true,

                    "maxhealth": 20,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "pull",
                    ],

                    "name": "Squire",
                    "faceKey": "fox",
                    "bodyKey": "good",

                    "dialogue": {
                        "death": [
                            "Fuck",
                        ],
                        "slowdeath": [
                            "...",
                        ],
                    },
                },
            }
        },
    },
    "configuration": {
        "darkness": false
    }
}
